<ng-container *ngFor="let row of rows; trackBy: trackByIndex">
  <content-loader viewBox="0 0 440 30">
    <svg:circle cx="10" cy="20" r="8" />
    <svg:rect x="25" y="15" rx="5" ry="5" width="400" height="10" />
  </content-loader>
</ng-container>
